import HeadingLevel, { type HeadingComponentType } from '../src/HeadingLevel.tsx';
export default HeadingLevel;
export type HeadingType = HeadingComponentType;
